var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.7075 0 0 4.7075 0 10.5C0 16.2925 4.7075 21 10.5 21C16.2925 21 21 16.2925 21 10.5C21 4.7075 16.2925 0 10.5 0ZM10.5 19.25C5.67 19.25 1.75 15.33 1.75 10.5C1.75 5.67 5.67 1.75 10.5 1.75C15.33 1.75 19.25 5.67 19.25 10.5C19.25 15.33 15.33 19.25 10.5 19.25Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1956 4.46429C9.4789 4.03512 7.56551 5.12593 7.04693 6.80685C6.88599 7.28967 7.15422 7.79037 7.61916 7.93343C8.08409 8.07649 8.58479 7.82614 8.74573 7.34332C8.99608 6.5565 9.96172 6.00216 10.7843 6.19886C11.589 6.39556 12.197 7.34332 12.036 8.1659C11.893 8.98847 11.1879 9.6812 9.91574 9.61201C9.91574 9.61201 9.65772 9.59647 9.4789 9.75741C9.2822 9.93623 9.1749 10.1687 9.1749 10.4369L9.15702 13.2265C9.15702 13.7272 9.55043 14.1207 10.0511 14.1207C10.5518 14.1207 10.9452 13.7272 10.9452 13.2265L10.9624 11.3608C10.9628 11.3123 10.9974 11.2709 11.0448 11.2604C12.3879 10.9644 13.561 9.85459 13.8064 8.46989C14.1283 6.73532 12.9302 4.89346 11.1956 4.46429Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16C9 15.4477 9.44772 15 10 15C10.5523 15 11 15.4477 11 16Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestion);
export default __webpack_public_path__ + "static/media/circle-question.4060970740a2e9376c1783261f751a92.svg";
export { ForwardRef as ReactComponent };